<template>
  <div class="TextFieldValidation" :class="'mb-' + margin">
    <ValidationProvider :name="name" :rules="rules" v-slot="{ errors }">
      <v-text-field
        class="TextFieldValidation rounded-xl"
        :value="value"
        :type="type"
        :error-messages="errors"
        :label="label"
        @input="v => $emit('change', v)"
        v-bind="{ ...$attrs }"
        @blur="$emit('blur')"
        :placeholder="placeholder"
      >
        <template v-slot:label>
          <span class="TextFieldValidation-label">{{ label }}</span>
        </template>
      </v-text-field>
    </ValidationProvider>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'textFieldValidation',
  inheritAttrs: false,

  components: { ValidationProvider },

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    label: String,
    margin: {
      type: Number,
      default: 2
    },
    name: {
      required: true,
      type: String
    },
    rules: {
      default: '',
      type: String
    },
    placeholder: {
      default: '',
      type: String
    },
    type: String,
    value: [String, Number]
  }
}
</script>

<style lang="scss">
.v-label--active {
  font-weight: 700;
  color: var(--v-secondary-base);
}
.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
  opacity: 0.3;
}
</style>
